import { API_REQUEST, UPLOAD_AGGREGATE_FILE } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const uploadAggregateFile = (
  folderKey: string, 
  currentSnapshotId: number | string, 
  campaignStatusCode: string, 
  file: FormData): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/snapshots/${currentSnapshotId}/file-upload/${folderKey}/${campaignStatusCode}`,
    next: UPLOAD_AGGREGATE_FILE,
    method: 'POST',
    authorization: true,
    data: file,
    isMultipart: true
  }

})